/**
 * Interfaces
 */

import {CompanyResponse} from "../company/types";
import {CurrencyResponse} from "../currency/types";


/** Offer item request. */
export interface OfferItemRequest {
    /** Title. */
    title?: string | undefined;
    /** Description. */
    description?: string | undefined;
    /** Price. */
    price?: number;
}

/** Offer item response. */
export interface OfferItemResponse {
    /** Title. */
    title?: string | undefined;
    /** Description. */
    description?: string | undefined;
    /** Price. */
    price?: number;
    /** Identity. */
    offerItemID: number;
}

/** Offer request. */
export interface OfferRequest {
    /** Number. */
    number?: string | undefined;
    /** Order Number. */
    orderNumber?: string | undefined;
    /** Realization date. */
    date?: string;
    /** Quote date. */
    quoteDate?: string;
    /** Commission Number. */
    commissionNumber?: string | undefined;
    /** Invoice Number. */
    invoiceNumber?: string | undefined;
    /** Exchange rate. */
    exchangeRate?: number;
    /** Note. */
    note?: string | undefined;
    /** Company ID FK. */
    companyID?: number | undefined;
    /** Currency ID FK. */
    currencyID?: number | undefined;
    offerState?: OfferState;
    realizationPlace?: RealizationPlace;
    /** Offer items. */
    items?: OfferItemRequest[] | undefined;
    /** File identifiers to attach. */
    files?: number[] | undefined;
}

/** Offer response. */
export interface OfferResponse {
    /** Number. */
    number?: string | undefined;
    /** Order Number. */
    orderNumber?: string | undefined;
    /** Realization date. */
    date?: Date;
    /** Quote date. */
    quoteDate?: Date;
    /** Commission Number. */
    commissionNumber?: string | undefined;
    /** Invoice Number. */
    invoiceNumber?: string | undefined;
    /** Exchange rate. */
    exchangeRate?: number;
    /** Note. */
    note?: string | undefined;
    /** Company ID FK. */
    companyID?: number | undefined;
    /** Currency ID FK. */
    currencyID?: number | undefined;
    offerState?: OfferState;
    realizationPlace?: RealizationPlace;
    /** Offer items. */
    items?: OfferItemResponse[] | undefined;
    /** Identity. */
    offerID: number;
    company?: CompanyResponse;
    currency?: CurrencyResponse;
    /** Offer files. */
    offerFiles?: OfferFileResponse[] | undefined;
    total?: number | undefined;
    /** Invoices. */
    invoices?: OfferInvoiceResponse[] | undefined;
}

export enum OfferState {
    New = "New",
    QuoteSend = "QuoteSend",
    Ordered = "Ordered",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum RealizationPlace {
    Internally = "Internally",
    Externally = "Externally",
}

export interface OfferFileResponse {
    /** Name. */
    name: string;
    /** Mime Type. */
    mimeType?: string | undefined;
    /** Line. */
    size?: number;
    /** Identity. */
    fileID: number;
    /** Identity GUID. */
    guid?: string;
    /** Offer file Identity. */
    offerFileID: number;
}

export interface OfferInvoiceResponse {
    /** Invoice ID. */
    invoiceID: number;
    /** Invoice Number. */
    number?: string | undefined;
}

export interface OfferTempPdf {
    /** Data. */
    data: Blob;
    /** Temp file Identifier. */
    id: number;
}

/** Send mail API model. */
export interface SendMailDto {
    /** Subject. */
    subject: string;
    /** Body. */
    body?: string | undefined;
    /** Recipients. */
    recipients?: string[] | undefined;
    /** Recipients. */
    attachments?: number[] | undefined;
}

